import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://gonohwcyzcwwiajyfjgy.supabase.co'
const supabaseKey = 'sb_publishable_AMnz47Uyz58ATJwZTyOvVg_Mfshvrd3'

export const supabase = createClient(supabaseUrl, supabaseKey)
